<div id="app-resource-add-dialog">
  <div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-primary">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
        <span class="title dialog-title">
          {{ 'RESOURCE-ADD-FORM.TITLE' | translate }}</span
        >
        <button
          mat-icon-button
          (click)="matDialogRef.close()"
          aria-label="Close dialog">
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar-row>
    </mat-toolbar>
    <mat-horizontal-stepper
      class="mat-elevation-z1 mat-stepper-horizontal"
      [linear]="true"
      labelPosition="bottom">
      <mat-step
        [completed]="addRessourceForm.get('ressourceName').valid && addRessourceForm.get('ressourceType').valid">
        <form fxLayout="column" fxFill [formGroup]="addRessourceForm">
          <h2 class="step-title">
            {{ 'RESOURCE-ADD-FORM.PAGE1.TITLE' | translate }}
          </h2>
          <div fxLayout="column" fxLayoutAlign="start start">
            <h3 class="labels">
              {{ 'RESOURCE-ADD-FORM.PAGE1.TYPE' | translate }}
            </h3>
            <mat-radio-group
              class="radio-ressource-type"
              formControlName="ressourceType"
              [(ngModel)]="selectedType">
              <mat-radio-button
                [value]="currentGECorrespondingTable.field_4 === 'fr-CH' ? 's' : 'z'"
                >{{ 'RESOURCE-ADD-FORM.PAGE1.ROOM' | translate
                }}</mat-radio-button
              >
              <mat-radio-button [value]="'e'"
                >{{ 'RESOURCE-ADD-FORM.PAGE1.EQUIPEMENT' | translate
                }}</mat-radio-button
              >
            </mat-radio-group>
          </div>
          <h3 class="labels">
            {{ 'RESOURCE-ADD-FORM.PAGE1.NAMELABEL' | translate }}
          </h3>
          <div fxLayout="column" fxLayoutAlign="start start">
            <div class="form-text">
              {{ 'RESOURCE-ADD-FORM.PAGE1.NAMEINFO' | translate }}
            </div>
            <mat-form-field class="step-input" fxFlex appearance="outline">
              <mat-label
                >{{ 'RESOURCE-ADD-FORM.PAGE1.NAMEPLACEHOLDER' | translate
                }}</mat-label
              >
              <input
                autocomplete="on"
                matInput
                formControlName="ressourceName"
                required />
              @if (addRessourceForm.get('ressourceName').hasError('pattern')) {
              <mat-error
                >{{ 'RESOURCE-ADD-FORM.PAGE1.NAMEPATTERNERROR' | translate
                }}</mat-error
              >
              } @else if
              (addRessourceForm.get('ressourceName').hasError('required')) {
              <mat-error
                >{{ 'RESOURCE-ADD-FORM.PAGE1.NAMEREQUIREDERROR' | translate
                }}</mat-error
              >
              } @else if
              (addRessourceForm.get('ressourceName').hasError('maxlength')) {
              <mat-error
                >{{ 'RESOURCE-ADD-FORM.PAGE1.NAMEMAXLENGTHERROR' | translate
                }}</mat-error
              >
              }
            </mat-form-field>
            <div
              fxLayout="column"
              class="mr-16 text-container"
              fxLayoutAlign="start start">
              <h3>
                {{ 'RESOURCE-ADD-FORM.PAGE1.PROVISIONALNAMESTITLE' | translate
                }}
              </h3>
              <div>
                {{ 'RESOURCE-ADD-FORM.PAGE1.PROVISIONALNAMESINFO' | translate
                }}
              </div>
            </div>
            <div fxLayout="column" class="name-input-container">
              <mat-form-field
                class="step-input name-input"
                fxFlex="50"
                fxFlex
                appearance="outline">
                <mat-label
                  >{{ 'RESOURCE-ADD-FORM.PAGE1.DISPLAYNAME' | translate
                  }}</mat-label
                ><input  matInput [value]="createDisplayName()" disabled
              /></mat-form-field>
              <mat-form-field
                class="step-input name-input"
                fxFlex="50"
                fxFlex
                appearance="outline">
                <mat-label
                  >{{ 'RESOURCE-ADD-FORM.PAGE1.EMAIL' | translate }}</mat-label
                ><input
                  matInput
                  [value]="createMailAddress() ? createMailAddress(): ''"
                  disabled
              /></mat-form-field>
            </div>
          </div>
        </form>
        <div
          class="general-container"
          fxLayout="row"
          fxLayoutAlign="end center">
          <button
            mat-raised-button
            matStepperNext
            type="button"
            color="accent"
            [disabled]="!(addRessourceForm.get('ressourceName').valid && addRessourceForm.get('ressourceType').valid)">
            {{ 'GENERAL.NEXT' | translate }}
          </button>
        </div>
      </mat-step>
      <mat-step>
        <form fxLayout="column" fxFill [formGroup]="addRessourceForm">
          <h2 class="step-title">
            {{ 'RESOURCE-ADD-FORM.PAGE2.TITLE' | translate }}
          </h2>
          <div fxLayout="column" fxLayoutAlign="start start">
            <h3
              class="labels"
              [style.display]="selectedType === 's' ? 'block' : 'none'">
              {{ 'RESOURCE-ADD-FORM.PAGE2.ROOMCAPACITYLABEL' | translate }}
            </h3>
            <h3
              class="labels"
              [style.display]="selectedType === 'e' ? 'block' : 'none'">
              {{ 'RESOURCE-ADD-FORM.PAGE2.EQUIPMENTQUANTITYLABEL' | translate
              }}
            </h3>
            <mat-form-field class="step-input" fxFlex appearance="outline">
              <mat-label
                [style.display]="selectedType === 's' ? 'block' : 'none'"
                >{{ 'RESOURCE-ADD-FORM.PAGE2.CAPACITY' | translate
                }}</mat-label
              >
              <mat-label
                [style.display]="selectedType === 'e' ? 'block' : 'none'"
                >{{ 'RESOURCE-ADD-FORM.PAGE2.QUANTITY' | translate
                }}</mat-label
              >
              <input autocomplete="on" matInput formControlName="capacity" />
              @if (addRessourceForm.get('capacity').hasError('pattern')) {
              <mat-error
                >{{ 'RESOURCE-ADD-FORM.PAGE2.CAPACITYPATTERNERROR' | translate
                }}</mat-error
              >
              }
            </mat-form-field>
          </div>
          <div fxLayout="column" fxLayoutAlign="start start">
            <h3 class="labels">
              {{ 'RESOURCE-ADD-FORM.PAGE2.ADDRESSLABEL' | translate }}
            </h3>
            <div class="form-text">
              {{ 'RESOURCE-ADD-FORM.PAGE2.INFOTEXTADDRESS' | translate }}
            </div>
            <mat-form-field class="step-input" fxFlex appearance="outline">
              <mat-label
                >{{ 'RESOURCE-ADD-FORM.PAGE2.ADDRESS' | translate }}</mat-label
              >
              <input autocomplete="on" matInput formControlName="address" />
            </mat-form-field>
          </div>
          <div fxLayout="column" fxLayoutAlign="start start">
            <h3 class="labels">
              {{ 'RESOURCE-ADD-FORM.PAGE2.LOCALITYLABEL' | translate }}
            </h3>
            <div class="form-text">
              {{ 'RESOURCE-ADD-FORM.PAGE2.INFOTEXTLOCALITY' | translate }}
            </div>
            <mat-form-field class="step-input" fxFlex appearance="outline">
              <mat-label
                >{{ 'RESOURCE-ADD-FORM.PAGE2.LOCALITY' | translate
                }}</mat-label
              >
              <input autocomplete="on" matInput formControlName="locality" />
            </mat-form-field>
          </div>
        </form>
        <div
          class="general-container"
          fxLayout="row"
          fxLayoutAlign="space-between center">
          <button
            class="btn-container"
            mat-raised-button
            matStepperPrevious
            type="button"
            color="accent">
            {{ 'GENERAL.PREVIOUS' | translate }}
          </button>
          <button mat-raised-button matStepperNext type="button" color="accent">
            {{ 'GENERAL.NEXT' | translate }}
          </button>
        </div>
      </mat-step>
      <mat-step>
        <div
          fxLayout="column"
          class="mr-16 text-container"
          fxLayoutAlign="start start">
          <h3 class="labels">
            {{ 'RESOURCE-ADD-FORM.PAGE3.RESERVATIONLABEL' | translate }}
          </h3>
          <div class="form-text">
            {{ 'RESOURCE-ADD-FORM.PAGE3.RESERVATIONINFOTEXT' | translate }}
          </div>
        </div>
        <div fxLayout="row" class="checkbox-container">
          <div fxLayout="column" class="checkboxes" fxFlex="50">
            <mat-checkbox class="form-text" [(ngModel)]="ajout_Directeur"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-DIR' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="ajout_ConseilDir"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-CONSDIR' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="ajout_secDir"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-SECDIR' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="ajout_PersonEns"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-ENS' | translate
              }}</mat-checkbox
            >
          </div>
          <div fxLayout="column" class="checkboxes" fxFlex="50">
            <mat-checkbox class="form-text" [(ngModel)]="ajout_ITRes"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-RI' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="ajout_ITGest"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-GESTIT' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="ajout_admin"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-ADMIN' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="ajout_Tech"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-TECH' | translate
              }}</mat-checkbox
            >
          </div>
        </div>
        <div
          class="general-container"
          fxLayout="row"
          fxLayoutAlign="space-between center">
          <button
            class="btn-container"
            mat-raised-button
            matStepperPrevious
            type="button"
            color="accent">
            {{ 'GENERAL.PREVIOUS' | translate }}
          </button>
          <button mat-raised-button matStepperNext type="button" color="accent">
            {{ 'GENERAL.NEXT' | translate }}
          </button>
        </div>
      </mat-step>
      <mat-step>
        <div
          fxLayout="column"
          class="mr-16 text-container"
          fxLayoutAlign="start start">
          <h3 class="labels">
            {{ 'RESOURCE-ADD-FORM.PAGE4.MODIFICATIONLABEL' | translate }}
          </h3>
          <div class="form-text">
            {{ 'RESOURCE-ADD-FORM.PAGE4.MODIFICATIONINFOTEXT' | translate }}
          </div>
        </div>
        <div fxLayout="row" class="checkbox-container">
          <div fxLayout="column" class="checkboxes" fxFlex="50">
            <mat-checkbox class="form-text" [(ngModel)]="access_Directeur"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-DIR' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="access_ConseilDir"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-CONSDIR' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="access_secDir"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-SECDIR' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="access_ITRes"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-RI' | translate
              }}</mat-checkbox
            >
          </div>
          <div fxLayout="column" class="checkboxes" fxFlex="50">
            <mat-checkbox class="form-text" [(ngModel)]="access_ITGest"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-GESTIT' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="access_admin"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-ADMIN' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="access_Tech"
              >{{ 'RESOURCE-DETAIL-FORM.FORM.GROUP-TECH' | translate
              }}</mat-checkbox
            >
          </div>
        </div>
        <div
          class="general-container"
          fxLayout="row"
          fxFill="100"
          *ngIf="isErrorCreateRessource">
          <div
            class="message-box error user-created"
            *ngIf="errorCreateRessource.error.code === 'ERR2'">
            {{ 'ERROR.2' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateRessource.error.code === 'ERR18'">
            {{ 'ERROR.18' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateRessource.error.code === 'ERR21'">
            {{ 'ERROR.21' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateRessource.error.code === 'ERR30'">
            {{ 'ERROR.30' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateRessource.error.code === 'ERR31'">
            {{ 'ERROR.31' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateRessource.error.code === 'ERR32'">
            {{ 'ERROR.32' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateRessource.error.code === 'ERR40'">
            {{ 'ERROR.40' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateRessource.error.code === 'ERR403'">
            {{ 'ERROR.402' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateRessource.error.code === undefined">
            {{ 'ERROR.2' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateRessource.error.code === null">
            {{ 'ERROR.2' | translate }}
          </div>
        </div>
        <div
          class="general-container"
          fxLayout="column"
          fxLayoutAlign="center center"
          *ngIf="isBusyCreateRessource">
          <div fxFlex="100">
            <mat-progress-spinner
              [color]="spinner.color"
              [mode]="spinner.mode"
              [value]="spinner.value"
              [diameter]="spinner.diameter">
            </mat-progress-spinner>
          </div>
          <br />
          <div fxFlex="100">{{ 'RESOURCE-ADD-FORM.LOADING' | translate }}</div>
        </div>
        <div
          class="success-container"
          fxLayout="column"
          fxFill="100"
          *ngIf="isRessourceCreated">
          <div class="row">
            <div class="message-box success user-created">
              {{ 'RESOURCE-ADD-FORM.SUCCESS' | translate }}
            </div>
          </div>
          <div class="row">
            <button
              mat-raised-button
              matStepperNext
              type="button"
              color="accent"
              class="btn-submit"
              (click)="matDialogRef.close()">
              {{ 'GENERAL.CONFIRMANDLEAVE' | translate }}
            </button>
          </div>
        </div>
        <div
          class="general-container"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          *ngIf="!isRessourceCreated">
          <button
            class="btn-container"
            mat-raised-button
            matStepperPrevious
            type="button"
            color="accent">
            {{ 'GENERAL.PREVIOUS' | translate }}
          </button>
          <button
            mat-raised-button
            type="button"
            color="accent"
            (click)="createRessource()"
            [disabled]="addRessourceForm.invalid">
            {{ 'GENERAL.SAVE' | translate }}
          </button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
